import React from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

function RequiredBadge({ variant = 'primary' }) {
  const baseStyles = {
    backgroundColor: colors.primaryScale['50'],
    color: colors.primaryScale['600'],
    borderRadius: '4px',
    paddingLeft: '0.5rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    paddingRight: '0.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto'
  };

  const styles = variant === 'secondary' ? {
    ...baseStyles,
    borderWidth: '1px',
    borderColor: colors.primaryScale['600']
  } : baseStyles;
  return (
    <Flex
      style={styles}
      textStyle="bodySm500"
    >
      Required
    </Flex>
  );
}

RequiredBadge.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary'])
};

export default RequiredBadge;
